document.addEventListener("DOMContentLoaded", () => {
  // --- Global State ---
  const mouse = { x: 0.5, y: 0.5, px: window.innerWidth / 2, py: window.innerHeight / 2 };
  const smoothMouse = { x: 0.5, y: 0.5, px: window.innerWidth / 2, py: window.innerHeight / 2 };
  const LERP_FACTOR = 0.08;

  window.addEventListener("mousemove", (e) => {
    mouse.px = e.clientX;
    mouse.py = e.clientY;
    mouse.x = e.clientX / window.innerWidth;
    mouse.y = e.clientY / window.innerHeight;
  });

  // --- Dashboard Animations ---
  
  // 1. Dashboard Lottie (Optimized with Canvas renderer)
  const initDashboardLottie = () => {
    const container = document.getElementById('hero-dashboard-lottie');
    if (!container || typeof lottie === 'undefined') return;

    const path = container.getAttribute('data-animation-path');
    lottie.loadAnimation({
      container: container,
      renderer: 'canvas',
      loop: true,
      autoplay: true,
      path: path,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
        clearCanvas: true
      }
    });
  };

  const initAboutLottie = () => {
    const container = document.getElementById('about-lottie');
    if (!container || typeof lottie === 'undefined') return;

    const path = container.getAttribute('data-animation-path');
    lottie.loadAnimation({
      container: container,
      renderer: 'canvas',
      loop: true,
      autoplay: true,
      path: path,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
        clearCanvas: true
      }
    });
  };

  initDashboardLottie();
  initAboutLottie();

  // --- Sticky Header ---
  const nav = document.querySelector(".nav");
  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      nav.classList.add("is-scrolled");
    } else {
      nav.classList.remove("is-scrolled");
    }
  });

  // --- Mobile Menu ---
  const navToggle = document.querySelector(".js-nav-toggle");
  const mobileOverlay = document.querySelector(".nav-mobile-overlay");

  if (navToggle && mobileOverlay) {
    navToggle.addEventListener("click", () => {
      navToggle.classList.toggle("is-active");
      mobileOverlay.classList.toggle("is-active");
      document.body.classList.toggle("locked");
    });

    mobileOverlay.querySelectorAll("a").forEach(link => {
      link.addEventListener("click", () => {
        navToggle.classList.remove("is-active");
        mobileOverlay.classList.remove("is-active");
        document.body.classList.remove("locked");
      });
    });
  }

  // --- GSAP Animations ---
  if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    // Smooth Scroll
    document.querySelectorAll('.js-scroll-link').forEach(link => {
      link.addEventListener('click', (e) => {
        const targetId = link.getAttribute('href');
        if (targetId.startsWith('#')) {
          e.preventDefault();
          const target = document.querySelector(targetId);
          if (target) {
            gsap.to(window, {
              duration: 1.5,
              scrollTo: { y: target, offsetY: 80 },
              ease: "power4.inOut"
            });
          }
        }
      });
    });

    // Hero Entry Animation
    const heroTl = gsap.timeline();
    heroTl.from(".hero-title", {
      y: 80,
      opacity: 0,
      duration: 1.4,
      ease: "power4.out",
      delay: 0.3
    })
    .from(".hero-label, .hero-sub, .hero-actions, .hero-visual", {
      y: 40,
      opacity: 0,
      duration: 1.2,
      stagger: 0.15,
      ease: "power3.out"
    }, "-=1");

    // General Reveal
    document.querySelectorAll('.reveal').forEach((el) => {
      gsap.from(el, {
        opacity: 0,
        y: 60,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      });
    });
  }

  // --- Counter Animation ---
  const counters = document.querySelectorAll(".js-count");
  const countObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const targetValue = el.getAttribute("data-target");
          const target = parseFloat(targetValue);
          
          if (isNaN(target)) {
            el.innerText = targetValue || "0";
            countObserver.unobserve(el);
            return;
          }

          const duration = 2000;
          const startTime = performance.now();

          const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            const currentCount = Math.floor(easeProgress * target);
            el.innerText = currentCount;

            if (progress < 1) requestAnimationFrame(animate);
            else el.innerText = target;
          };

          requestAnimationFrame(animate);
          countObserver.unobserve(el);
        }
      });
    },
    { threshold: 0.1 }
  );

  counters.forEach((counter) => countObserver.observe(counter));

  // --- FAQ Accordion ---
  const faqItems = document.querySelectorAll(".js-faq-item");
  faqItems.forEach(item => {
    const header = item.querySelector(".js-faq-item-header") || item.querySelector(".faq-item-header");
    header.addEventListener("click", () => {
      const isActive = item.classList.contains("is-active");
      faqItems.forEach(o => o.classList.remove("is-active"));
      if (!isActive) item.classList.add("is-active");
    });
  });
});
